<template>
  <main class="site-closed" role="alert">
    <p>抱歉！该站点已经被管理员停止运行！</p>
  </main>
</template>

<style scoped>
.site-closed {
  position: fixed;
  inset: 0;
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
  box-sizing: border-box;
  padding: 24px;
  background: #fff;
  color: #333;
  font-family: Arial, "Microsoft YaHei", sans-serif;
  font-size: 24px;
  line-height: 1.5;
  text-align: center;
}

.site-closed p {
  margin: 0;
}
</style>
